import { Subscription, SubscriptionApiInterface } from "@syadem/kairos-subscription-js";
import { AppStore } from "../store";
import { Service } from "./service";
import { Success } from "../actionResult";

interface Payload {
  subscription: {
    quantity: number;
  };
  organizationId: string;
}

export class UpdateSubscriptionQuantityService implements Service<Payload, Subscription> {
  constructor(
    private readonly store: AppStore,
    private readonly subscriptionApi: SubscriptionApiInterface
  ) {}

  async call({ subscription, organizationId }: Payload): Promise<Success<Subscription>> {
    const apiSubscription = await this.subscriptionApi.updateSubscriptionQuantity(organizationId, { subscription });

    this.store.setState((state) => {
      if (state.subscriptionOrganizations && state.subscriptionOrganizations[organizationId]) {
        return {
          ...state,
          subscriptionOrganizations: {
            ...state.subscriptionOrganizations,
            [organizationId]: {
              ...state.subscriptionOrganizations[organizationId],
              subscription: apiSubscription
            }
          }
        };
      } else {
        return {
          ...state,
          subscriptionOrganizations: {
            ...(state.subscriptionOrganizations || {}),
            [organizationId]: {
              id: organizationId,
              invoices: [],
              defaultPaymentMethod: null,
              subscription: apiSubscription
            }
          }
        };
      }
    })

    return {
      type: "success",
      value: apiSubscription
    };
  }
}
